import { Col, Label, ReactSelectBox } from "client/CommonComponents";

const Development = (props?: any) => {
  const managedEquipmentValues = props?.managedEquipmentValues;
  const handleCategoryChange = props?.handleCategoryChange;
  const manufacturerDropdownList = props?.manufacturerDropdownList;
  const categoryDropdownList = props?.categoryDropdownList;
  const managedEquipRef = props?.managedEquipRef;
  const handleManufacturerChange =props?.handleManufacturerChange;

  return (<>
    <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="Development_Default_Label">Category</Label>
        <ReactSelectBox
          options={categoryDropdownList}
          onChange={(item: any, e: any) => handleCategoryChange(e, item,'category')}
          value={managedEquipmentValues?.category}
          selectRef={(element:any)=>managedEquipRef.current[1] = element}
          
         data-attribute="Development_Default_SearchSelectBox" />
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="Development_Default_Label_2">Manufacturer</Label>
        <ReactSelectBox
          options={manufacturerDropdownList}
          onChange={(item: any, e: any) => handleManufacturerChange(e, item,'manufacturer')}
          value={managedEquipmentValues?.manufacturer}
          selectRef={(element:any)=>managedEquipRef.current[2] = element}

         data-attribute="Development_Default_SearchSelectBox_2" />
      </Col>
  </>)
}

export default Development;
